import { domainEvent, DomainEvent, MessageName } from "@lookiero/messaging";

const CHECKOUT_RESET = "checkout_reset";

interface CheckoutResetPayload {
  readonly aggregateId: string;
}

interface CheckoutReset extends DomainEvent<typeof CHECKOUT_RESET>, CheckoutResetPayload {}

interface CheckoutResetFunction {
  (payload: CheckoutResetPayload): CheckoutReset;
}

const checkoutReset: CheckoutResetFunction = ({ aggregateId }) => domainEvent({ aggregateId, name: CHECKOUT_RESET });

const isCheckoutReset = (event: DomainEvent<MessageName>): event is CheckoutReset => event.name === CHECKOUT_RESET;

export type { CheckoutReset };
export { CHECKOUT_RESET, checkoutReset, isCheckoutReset };
